/* here we define the primary color code of the applications */;

export const PRIMARY_COLOR = '#89cce2'